(() => {
  'use strict';

  if (window.FamliDispatchCountdownLoaded) return;
  window.FamliDispatchCountdownLoaded = true;

  const TIME_ZONE = 'Europe/Copenhagen';
  const CUTOFF_HOUR = 13;

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  const getCopenhagenTime = () => {
    const parts = formatter.formatToParts(new Date());
    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    return {
      weekday: values.weekday,
      hour: Number(values.hour),
      minute: Number(values.minute),
      second: Number(values.second)
    };
  };

  const pad = (value) => String(value).padStart(2, '0');

  const update = () => {
    const nodes = document.querySelectorAll('[data-famli-dispatch]');
    if (!nodes.length) return;

    const now = getCopenhagenTime();
    const weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(now.weekday);
    const secondsNow = (now.hour * 3600) + (now.minute * 60) + now.second;
    const cutoff = CUTOFF_HOUR * 3600;
    const shipsToday = weekday && secondsNow < cutoff;

    let countdown = '';
    if (shipsToday) {
      const left = cutoff - secondsNow;
      countdown = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
    }

    nodes.forEach((node) => {
      const text = node.querySelector('[data-famli-dispatch-text]');
      if (!text) return;
      const context = node.dataset.famliDispatchContext || 'product';

      node.classList.toggle('is-next-day', !shipsToday);

      if (shipsToday) {
        const lead = context === 'cart' ? 'Læg ordren inden' : 'Bestil inden';
        text.innerHTML = `${lead} <strong>${countdown}</strong> – så sender vi i dag`;
      } else {
        text.textContent = 'Bestil nu – vi sender næste hverdag';
      }
    });
  };

  update();
  window.setInterval(update, 1000);
})();
